import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { GroupSettingsRes } from "../../types/ResType";

// export const useGroupSettings = () => {
//   return useQuery<GroupSettingsRes, Error>(
//     ["get-Group-settings"],
//     async () => {
//       const response = await axiosInstance.post<GroupSettingsRes>("get-Group-settings", {});
//       return response.data;
//     },
//     {
//       staleTime: Infinity,
//       cacheTime: Infinity,
//     },
//   );
// };

export const useGroupSettings = () => {
  return useQuery<GroupSettingsRes, Error>(
    ["get-group-settings"],
    async () => {
      // ✅ Backend API not available yet
      // const response = await axiosInstance.post<GroupSettingsRes>(
      //   "get-group-settings",
      //   {}
      // );
      // return response.data;

      // ✅ Temporary Mock Response (Frontend Safe)
    return {
        success: true,
        message: "Mock group settings loaded successfully",
        settings: [
          {
            setting_id: 1,
            max_members: 100,
            createdAt: new Date(),
            updatedAt: new Date(),
          },
        ],
      };
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );
};